import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import common from '~/common';
import Login_Bg from 'images/Login_Bg.webp';

const styles = theme => ({
  text: { color: 'white', fontSize: 14, lineHeight: '20px', display: 'flex', justifyContent: 'center' },
  link: { cursor: 'pointer', marginLeft: 4, marginRight: 4 },
});

class App extends Component {
  state={ c1: false, c2: false, c3: false }
  openPage=t => {
    const w = window.open('about:blank');
    w.location.href = t;
  }

  mv1=() => this.setState({ c1: true })
  mv2=() => this.setState({ c2: true })
  mv3=() => this.setState({ c3: true })
  mt1=() => this.setState({ c1: false })
  mt2=() => this.setState({ c2: false })
  mt3=() => this.setState({ c3: false })
  render () {
    const { classes, isManage } = this.props;
    const { c1, c2, c3 } = this.state;
    const link = [
      'https://www.moea.gov.tw/Mns/populace/content/ContentFoot.aspx?menu_id=13863',
      'https://www.moea.gov.tw/Mns/populace/content/ContentFoot.aspx?menu_id=2290',
      'https://www.moea.gov.tw/Mns/populace/content/ContentFoot.aspx?menu_id=2291',
    ];
    return (
      <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
        <img style={{ width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }} src={Login_Bg} alt='' />
        <div style={{
          position: 'absolute',
          bottom: 26,
          left: '50%',
          transform: 'translate( -50%, 0%)',
        }}
        >
          <div className={classes.text}>
            本網站支援Safari、Firefox及Chrome、Edge，最佳瀏覽解析度為1350x800以上
          </div>
          <div className={classes.text}>
            {`© ${isManage ? common.backTitle : common.frontTitle} All rights reserved.`}
            {/* {`© 2022 ${isManage ? common.backTitle : common.frontTitle} All rights reserved.`} */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isManage: state.isManage,
});

export default withStyles(styles)(connect(mapStateToProps)(App));
